module.exports = __webpack_public_path__ + "static/media/emp.c5ab20ad.png";